import { render, staticRenderFns } from "./AppImageInput.vue?vue&type=template&id=08045a14"
import script from "./AppImageInput.vue?vue&type=script&lang=js"
export * from "./AppImageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports